export const FirebaseConfig = {
	"projectId": "lavaville-321taxi",
	"appId": "1:261399405583:web:9736a5fb544ec7d881af7a",
	"databaseURL": "https://lavaville-321taxi-default-rtdb.firebaseio.com",
	"storageBucket": "lavaville-321taxi.firebasestorage.app",
	"apiKey": "AIzaSyAnwIfuOlnvJA6Z91jYTj5FBJiZ2MOXPd4",
	"authDomain": "lavaville-321taxi.firebaseapp.com",
	"messagingSenderId": "261399405583"
};